var _rect, _path, _rect2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 105,
    viewBox: "0 0 152 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.11523,
    y: 40.4138,
    width: 44.7998,
    height: 23.8932,
    rx: 5.97331,
    fill: "#F875B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0605 47.8241C57.8433 50.2081 57.8433 54.5125 55.0605 56.8966L35.4952 73.6585C31.6202 76.9782 25.6356 74.2248 25.6356 69.1222L25.6356 35.5984C25.6356 30.4958 31.6202 27.7424 35.4952 31.0622L55.0605 47.8241Z",
    fill: "#F875B4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 44.7998,
    height: 23.8932,
    rx: 5.97331,
    transform: "matrix(-1 0 0 1 120.115 40.4138)",
    fill: "#7E60E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1699 47.8241C64.3872 50.2081 64.3872 54.5125 67.1699 56.8966L86.7353 73.6585C90.6103 76.9782 96.5949 74.2248 96.5949 69.1222L96.5949 35.5984C96.5949 30.4958 90.6103 27.7424 86.7353 31.0622L67.1699 47.8241Z",
    fill: "#7E60E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardArrows);
export default __webpack_public_path__ + "static/media/card_arrows.4b643afa13f07712b9abfeac6e8187d5.svg";
export { ForwardRef as ReactComponent };